import React from 'react';
import PropTypes from 'prop-types';
import {Result, Button} from 'antd';

import {trb} from "../../Utilities";

const ButtonGroup = Button.Group;

export const MessageResult = (props) => {
    return <Result
        status={props.status}
        title={trb(props.title)}
        subTitle={trb(props.subTitle)}
        extra={
            <React.Fragment>
                <div className="mb-3 text-right d-none d-sm-block">
                    <ButtonGroup>
                        {props.buttons && props.buttons.map((item, index) =>
                            <Button
                                key={index}
                                onClick={item.func}
                                {...item.props}
                            >{trb(item.title)}</Button>
                        )}
                    </ButtonGroup>
                </div>
                <div className="mb-3 text-right d-block d-sm-none">
                    {props.buttons && props.buttons.map((item, index) =>
                        <Button
                            className='mb-2'
                            key={index}
                            onClick={item.func}
                            block
                            {...item.props}
                        >{trb(item.title)}</Button>
                    )}
                </div>
            </React.Fragment>
        }
    />
};

MessageResult.propTypes = {
    status: PropTypes.oneOf(['success', 'error', 'info', 'warning']).isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    buttons: PropTypes.array,
};